import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StaffOrderDetailFacade } from './staff-order-detail.facade';

@Component({
  selector: 'lib-staff-order-detail-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, NgClass, DatePipe],
  templateUrl: './staff-order-detail-header.component.html',
  styleUrl: './staff-order-detail-header.component.scss',
})
export class StaffOrderDetailHeaderComponent {
  readonly facade = inject(StaffOrderDetailFacade);
}
